module.exports = __webpack_public_path__ + "img/MTNza Icon 0.1cc47336.svg";